export default __webpack_public_path__ + "static/media/yellowborder.39b54861.png";